<template>
  <img src="/img/placeholder-image.svg" />
</template>
